import { styled } from '@mui/material/styles';

export const CheckboxFieldStyles = styled('div')(
    ({ theme }) => `
    padding: 3px 0 3px 0;
    display: flex;
    align-items: center;

    a {
        font-family: 'Inter', sans-serif;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        color: ${theme.palette.grey[900]};
    }
`,
);
